import Loadable from 'react-loadable'
import LoadingBlock from "../Loading/LoadingBlock";

export default Loadable({
    loader: () =>
        import('./Notification'),
    loading: LoadingBlock
})
